import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../models/user';
import {Farmer} from '../models/farmer';
import {AnalyticsModel} from '../models/analytics-model';
import {NavigatorUtils} from '../utils/navigator.utils';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/spianalytics';

@Injectable()
export class SpianalyticsService {
  constructor(private http: HttpClient, private navigatorUtils: NavigatorUtils) {
  }

  runQuery(numgraphe: number, selectedYear = null, currentCenter = null) {
    const url = `${apiUrl}/runQuery/${numgraphe}`;

    let params = new HttpParams();
    if (selectedYear) {
      params = params.set('year', String(selectedYear));
    } else {
      params = params.set('year', String(-1));
    }
    if (currentCenter) {
      params = params.set('centerId', String(currentCenter));
    } else {
      params = params.set('centerId', String(-1));
    }

    return this.http.get<any>(url , {params: params});
  }

  sendStats(action: string, moreInfo: string) {

    /**
     browser: "Chrome"
     browser_version: "72.0.3626.109"
     device: "Unknown"
     os: "Windows"
     os_version: "windows-10"
     userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.109 Safari/537.36"
     */
    let analytics: AnalyticsModel;
    analytics = new AnalyticsModel();
    analytics.userName = '' ; //$rootScope.account.email,
    analytics.action = action;  //'Connexion'
    analytics.moreInfo = moreInfo;  //'pas info'
    analytics.onLine = navigator.onLine;
    analytics.language = navigator.language;
    analytics.browserName = this.navigatorUtils.deviceInfo ? this.navigatorUtils.deviceInfo.browser : null;  //navigatorUtils.finBrowser().browserName
    analytics.majorVersion = this.navigatorUtils.deviceInfo ?  this.navigatorUtils.deviceInfo.browser_version : null;
    analytics.osName = this.navigatorUtils.deviceInfo.os_version;
    analytics.ip = '' //navigatorUtils.findAdresseIp(
    analytics.userAgent = this.navigatorUtils.deviceInfo.userAgent;

    const url = `${apiUrl}/save`;
    return this.http.post<User>(url , analytics, httpOptions).subscribe(
      data => {
        console.log('Trakking ' + action + ' action');
      },
      error => {
        console.log('Error to track ' + action);
      });
  }
}
